import produce from 'immer';

// TYPES
import { Types, CadastrarMunicipio } from './types';
import { ReducerAction } from '../../../../../../types';

export const INITIAL_STATE: CadastrarMunicipio = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): CadastrarMunicipio {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CADASTRAR_MUNICIPIO_REQUEST: {
				draft.status = INITIAL_STATE.status;
				break;
			}

			case Types.CADASTRAR_MUNICIPIO_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.CADASTRAR_MUNICIPIO_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CADASTRAR_MUNICIPIO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
	});
}
